const linksPagamentosMenu = {
    label: 'Links de pagamentos',
    icon: 'pi pi-fw pi-users',
    to: '/vendas/linkspagamentos',
    rules: ['CHECKOUTS-PAGAMENTOS-00'],
};

export default linksPagamentosMenu;
